/* ==========================================================
   Comparison Cards — behavior
   Two independent, dependency-free pieces:
   1) The same one-shot, GSAP-free stagger-in entrance animation
      used across the theme's other custom sections (see
      product-showcase.js for the full explanation) — content is
      always visible by default, this only ever ADDS motion on top,
      once per page load.
   2) Mobile pagination dots: a SEPARATE, always-on (not one-shot)
      IntersectionObserver watches which card is currently centered
      in the horizontally-scrolling strip and keeps the matching dot
      marked active. Clicking a dot scrolls that card into view.
      No library, no CDN request — plain IntersectionObserver and
      scrollIntoView, both native browser APIs.
   ========================================================== */

(function () {
  "use strict";

  var CONTENT_STAGGER = 0.12;
  var GROUP_DELAY = 0.12;

  function init(root) {
    initStagger(root);
    initDots(root);
  }

  /* ---------- one-shot stagger-in (heading, then card row) ---------- */

  function initStagger(root) {
    if (root.dataset.stagger === "false") return;
    if (typeof IntersectionObserver === "undefined") return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var groupEls = Array.prototype.slice.call(root.querySelectorAll("[data-stagger-group]"));
    groupEls.forEach(function (groupEl, order) {
      var items = Array.prototype.slice.call(groupEl.querySelectorAll("[data-stagger-item]"));
      if (!items.length) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            playGroup(items, order);
          });
        },
        { threshold: 0 }
      );
      observer.observe(groupEl);
    });
  }

  function playGroup(items, order) {
    var groupDelay = order * GROUP_DELAY;
    items.forEach(function (item, i) {
      item.classList.add("stagger-pre");
      item.style.transitionDelay = (groupDelay + i * CONTENT_STAGGER) + "s";
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        items.forEach(function (item) {
          item.classList.remove("stagger-pre");
          item.classList.add("stagger-in");
        });
      });
    });
  }

  /* ---------- mobile pagination dots (always-on, not one-shot) ---------- */

  function initDots(root) {
    var track = root.querySelector("[data-cmp-track]");
    var dotsWrap = root.querySelector("[data-cmp-dots]");
    if (!track || !dotsWrap) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll("[data-cmp-card]"));
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll("[data-cmp-dot]"));
    if (!cards.length || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === index);
      });
    }

    setActive(0);

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        var card = cards[i];
        if (!card) return;
        card.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
      });
    });

    if (typeof IntersectionObserver === "undefined") return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = cards.indexOf(entry.target);
          if (index !== -1) setActive(index);
        });
      },
      { root: track, threshold: 0.6 }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  document.querySelectorAll("[data-comparison-cards]").forEach(init);
})();